"use client"

import { createContext, useState, useEffect, useContext } from "react"
import { useAuth } from "./AuthContext"

// const URL = "http://localhost:5500/api"
const URL = "/api"

// Create context
const ObservationContext = createContext()

// Provider component
export const ObservationProvider = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const [observations, setObservations] = useState([])
  const { currentUser } = useAuth()

  const refreshObservations = async () => {
      if (!currentUser) {
        return
      }
    try {
      setLoading(true)
      if (!currentUser) {
        return
      }
      console.log("fdsads");
      
      const response = await (await fetch(`${URL}/obs/getObs`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${currentUser.token}`,
        },
      })).json()

      if (response.error) {
        console.error("Error fetching observations:", response.error)
        return
      }
      setObservations(response.obs)
      localStorage.setItem("obs", JSON.stringify(response.obs))
      
      setLoading(false)
    }catch (err){
      setObservations(JSON.parse(localStorage.getItem("obs")))
      setLoading(false)
    }
}

  // Load observations from localStorage on mount or when user changes
  useEffect(() => {
    refreshObservations()
  }, [currentUser])


  // Save observations to localStorage whenever they change
  useEffect(() => {

  }, [observations, currentUser])

  // Add a new observation
  const addObservation = async (observation) => {
    setLoading(true)
    const newObservation = {
      ...observation,
      id: Date.now().toString(),
      createdAt: new Date().toISOString(),
    }
    const response = await (await fetch(`${URL}/obs/addObs`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${currentUser.token}`,
      },
      body: JSON.stringify({ obsInfos: newObservation }),
    })).json()



    if (response.error) {
      console.error("Error adding observation:", response.error)
      return
    } else {
      setLoading(false)
      return refreshObservations()
    }
  }

  // Update an existing observation
  const updateObservation = (id, updatedObservation) => {
    setObservations(observations.map((obs) => (obs.id === id ? { ...updatedObservation, id } : obs)))
  }

  // Delete an observation
  const deleteObservation = async (id) => {
    const response = await fetch(`${URL}/obs/deleteObs`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${currentUser.token}`,
      },
      body: JSON.stringify({ obs: { id } }),
    })

    refreshObservations()
  }

  // Get a specific observation by ID
  const getObservation = (id) => {
    return observations.find((obs) => obs.id === id) || null
  }

  // Get observations for a specific date
  const getObservationsForDate = (date) => {

    return observations.filter((obs) => {
      return obs.date === date
    })
  }

  // Check if a date has any observations
  const hasObservationsOnDate = (date) => {

    return observations.some((obs) => {


      return obs.date === date
    })
  }



  return (
    <ObservationContext.Provider
      value={{
        observations,
        addObservation,
        updateObservation,
        deleteObservation,
        getObservation,
        getObservationsForDate,
        hasObservationsOnDate,
        loading
      }}
    >
      {children}
    </ObservationContext.Provider>
  )
}

// Custom hook to use the context
export const useObservations = () => {
  const context = useContext(ObservationContext)
  if (!context) {
    throw new Error("useObservations must be used within an ObservationProvider")
  }
  return context
}

